import * as React from 'react';
import { Box, SectionHeading as UISectionHeading } from '../common/ui';
export default function SectionHeading({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mb: 'sectionHeadingMarginBottom',
        pageBreakInside: 'avoid',
      }}
    >
      <UISectionHeading>{children}</UISectionHeading>
      <Box
        sx={{
          flexGrow: 1,
          height: 2,
          ml: 16,
          backgroundColor: 'accent',
          mt: 9,
        }}
      />
    </Box>
  );
}
